<template>
  <div id="app" class="d-flex flex-column min-vh-100">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "app"
  }
</script>

<style lang="scss" scoped>
</style>
